import Vue from 'vue';
// 懒加载 - 半成品
Vue.directive('loadmore', {
  bind (el, binding) {
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
    if(!SELECTWRAP_DOM) throw new Error('无法获取el-select-dropdown__wrap节点');
    SELECTWRAP_DOM.addEventListener('scroll', function () {
      // 滚动到底部时触发调用
      const CONDITION = SELECTWRAP_DOM.scrollHeight - Math.ceil(SELECTWRAP_DOM.scrollTop) <=
        SELECTWRAP_DOM.clientHeight;
      if (CONDITION) {
        // 调用methods中绑定的方法
        binding.value();
      }
    });
  }
});



// WEBPACK FOOTER //
// ./src/util/directives.js